require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-loans-and-credit-cards.json") })
        }
      }, "path---es-loans-and-credit-cards");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-loans-and-credit-cards!./.cache/json/es-loans-and-credit-cards.json
// module id = 2578
// module chunks = 231608221292675